module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.getProfileHaveClient) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Депозитарий обеспечивает Юридическую Значимость Вашим документам.")])]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Для загрузки документов, необходимо определить Юридическое лицо которое Вы представляете.\n        Регистрируйтесь и загрузите свои первые документы.\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Регистрация")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getProfileHaveClient) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "light": "",
      "prominent": "",
      "flat": ""
    }
  }, [_c('v-flex', [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.cxt.getTitleIcon())
    }
  }), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-toolbar-title', [_vm._v(_vm._s(_vm.cxt.getTitle()))]) : _vm._e()], 1), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "pl-3": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs6": ""
    }
  }, [_c('v-chips-field', {
    attrs: {
      "emptyChip": "Метки",
      "solo": "",
      "flat": "",
      "items": _vm.chipsItems,
      "chipSize": _vm.getIsMobile ? 12 : 25
    },
    on: {
      "remove": _vm.removeInn,
      "click": _vm.selectInn
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "sm4": "",
      "xs4": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "autofocus": "",
      "label": "Фильтр",
      "value": _vm.cxt.filterString,
      "solo": "",
      "flat": ""
    },
    on: {
      "input": _vm.onChangeFilter
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cxt.isSelectMode()),
      expression: "!cxt.isSelectMode()"
    }]
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cxt.isFilterMode()),
      expression: "!cxt.isFilterMode()"
    }]
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.addFile()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)]), _vm._v(" "), _c('v-ops-btn', {
    attrs: {
      "cxt": _vm.cxt,
      "flat": ""
    }
  })], 1), _vm._v(" "), _c('v-progress-linear', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0"
    },
    attrs: {
      "height": "2",
      "active": _vm.getItemSet.isProcessing(),
      "indeterminate": true
    }
  }), _vm._v(" "), _c('v-card-scroll', {
    ref: "cardScroll",
    on: {
      "nextPage": _vm.nextPage
    }
  }, [_c('v-list', {
    attrs: {
      "two-line": "",
      "dense": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-actions-btn', {
    attrs: {
      "caption": _vm.folderActionsCaption,
      "actions": _vm.folderActions
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.depoFolders), function(item) {
    return _c('v-list-tile', {
      key: item.uid,
      attrs: {
        "avatar": ""
      },
      on: {
        "click": function($event) {
          !_vm.cxt.isSelectMode() ? _vm.setFolder(item.fileName) : _vm.cxt.select(item.uid)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("folder")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.docName))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.subtitle))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('span', [_c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.cxt.isSelectMode()),
        expression: "!cxt.isSelectMode()"
      }],
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openFolder(item.uid)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v("info_outline")])], 1), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(item.uid)),
        expression: "cxt.check(item.uid)"
      }]
    }, [_vm._v("check_box")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(item.uid)),
        expression: "cxt.uncheck(item.uid)"
      }]
    }, [_vm._v("check_box_outline_blank")])], 1)])], 1)
  }), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _vm._l((this.filteredItems), function(item) {
    return [(item.header) ? _c('v-subheader', {
      domProps: {
        "textContent": _vm._s(item.header)
      }
    }) : (item.divider) ? _c('v-divider', {
      attrs: {
        "inset": item.inset
      }
    }) : _c('v-list-tile', {
      key: item.uid,
      on: {
        "click": function($event) {
          !_vm.cxt.isSelectMode() ? _vm.openFile(item.uid) : _vm.cxt.select(item.uid)
        }
      }
    }, [_c('v-list-tile-avatar', {
      attrs: {
        "tile": ""
      }
    }, [_c(_vm.createPreview(item), {
      tag: "v-component"
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('b', [_vm._v(_vm._s(item.docName))])]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('a', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          !_vm.cxt.isSelectMode() ? _vm.open(item) : _vm.cxt.select(item.uid)
        }
      }
    }, [_vm._v(_vm._s(item.uid))])])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('span', [_c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(item.uid)),
        expression: "cxt.check(item.uid)"
      }]
    }, [_vm._v("check_box")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(item.uid)),
        expression: "cxt.uncheck(item.uid)"
      }]
    }, [_vm._v("check_box_outline_blank")])], 1), _vm._v(" "), _c('v-list-tile-action-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.cxt.isSelectMode()),
        expression: "!cxt.isSelectMode()"
      }]
    }, [_c('p')]), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v(_vm._s(_vm.formats.blank(item.uploaded, _vm.formats.formatDate)))])], 1)], 1)]
  })], 2)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-782d857f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/depo/DocList.vue
// module id = 1179
// module chunks = 1